import React, { useState } from "react";

import { Button, Modal, Row, Upload } from "antd";

import {
  PictureOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const ProductDetailExplainComponent = ({
  isExplainProductModalOpen,
  handleExplainProductModalCancel,
  handleExplainProductModalOk,
  productDescriptionImg,
  handleExplainProductImageSave,
  handleDeletedImageUid,
  refProductDescriptionImg,
}) => {
  const [clickImageUid, setClickImageUid] = useState(
    productDescriptionImg[0].uid,
  );

  const [productExplainImgList, setProductExplainImgList] = useState(
    productDescriptionImg,
  );

  const [deletedImageUid, setDeletedImageUid] = useState([]);

  const imageSave = () => {
    if (window.confirm("현재 상태를 저장하시겠습니까?")) {
      handleExplainProductImageSave(productExplainImgList);
      handleDeletedImageUid(deletedImageUid);
    }
  };

  const handleProductExplainImg = (event, name) => {
    const file = event.file;
    const fileList = event.fileList;
    const findClickIdx = productExplainImgList.findIndex(
      (item) => item.uid === clickImageUid,
    );

    if (name === "add") {
      if (findClickIdx !== -1) {
        const addFiles = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: URL.createObjectURL(file),
          originFileObj: file,
        };
        const findIdx = fileList.findIndex((img) => img.uid === file?.uid);
        const newFileList = (prev) => [
          ...prev.slice(0, findClickIdx + 1 + findIdx),
          addFiles,
          ...prev.slice(findClickIdx + 1 + findIdx),
        ];

        setProductExplainImgList(newFileList);
        setClickImageUid(fileList[fileList.length - 1].uid);
      } else {
        // idx가 없을 때 -> 사진을 다 삭제하고 다시 넣을 때
        const addFiles = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: URL.createObjectURL(file),
          originFileObj: file,
        };
        setProductExplainImgList((prev) => [...prev, addFiles]);
        setClickImageUid(fileList[fileList.length - 1].uid);
      }
    } else if (name === "change") {
      // 교체하기
      const changeFiles = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: URL.createObjectURL(file),
        originFileObj: file,
      };
      const newFileList = (prev) => [
        ...prev.slice(0, findClickIdx),
        changeFiles,
        ...prev.slice(findClickIdx + 1),
      ];
      setProductExplainImgList(newFileList);

      const deletedUid = productExplainImgList[findClickIdx].uid;
      if (
        refProductDescriptionImg.findIndex((img) => img.uid === deletedUid) >= 0
      ) {
        setDeletedImageUid((prev) => [...prev, deletedUid]);
      }

      setClickImageUid(changeFiles.uid);
    }
  };

  const handleProductExplainImgDelete = () => {
    const findClickIdx = productExplainImgList.findIndex(
      (item) => item.uid === clickImageUid,
    );

    const productExplainImgListLength = productExplainImgList.length;

    if (
      productExplainImgListLength !== 0 &&
      findClickIdx === productExplainImgListLength - 1
    ) {
      setClickImageUid(
        productExplainImgList[productExplainImgListLength - 2]?.uid || "",
      );
    } else {
      setClickImageUid(productExplainImgList[findClickIdx + 1]?.uid || "");
    }

    const deletedUid = productExplainImgList[findClickIdx].uid;
    if (
      refProductDescriptionImg.findIndex((img) => img.uid === deletedUid) >= 0
    ) {
      setDeletedImageUid((prev) => [...prev, deletedUid]);
    }

    const newImageList = productExplainImgList.filter(
      (img, index) => index !== findClickIdx,
    );
    setProductExplainImgList(newImageList);
  };

  const handleKeyDownImgDelete = (e) => {
    if (e.key === "Delete" || e.key === "Backspace") {
      const findClickIdx = productExplainImgList.findIndex(
        (item) => item.uid === clickImageUid,
      );

      const productExplainImgListLength = productExplainImgList.length;

      if (
        productExplainImgListLength !== 0 &&
        findClickIdx === productExplainImgListLength - 1
      ) {
        setClickImageUid(
          productExplainImgList[productExplainImgListLength - 2]?.uid || "",
        );
      } else {
        setClickImageUid(productExplainImgList[findClickIdx + 1]?.uid || "");
      }

      const deletedUid = productExplainImgList[findClickIdx].uid;
      if (
        refProductDescriptionImg.findIndex((img) => img.uid === deletedUid) >= 0
      ) {
        setDeletedImageUid((prev) => [...prev, deletedUid]);
      }

      const newImageList = productExplainImgList.filter(
        (img, index) => index !== findClickIdx,
      );
      setProductExplainImgList(newImageList);
    }
  };

  const handleAllImgDelete = () => {
    if (
      window.confirm(
        "등록된 이미지를 포함하여 입력하신 모든 이미지가 지워집니다.\n삭제하시겠습니까?",
      )
    ) {
      const allUid = productExplainImgList.map((item) => item.uid);
      setDeletedImageUid((prev) => [...prev, ...allUid]);

      setProductExplainImgList([]);
    }
  };

  return (
    <Modal
      wrapClassName="product-detail-explain-modal"
      className="related-product-modal-wrap product-explain-modal-body"
      title={
        <div className="modal-title">
          <div className="related-product-modal-header">
            상품 상세페이지 수정
          </div>
          <Row className="product-explain-button-wrap" justify="space-between">
            <div>
              <Upload
                onChange={(event) => handleProductExplainImg(event, "add")}
                showUploadList={false}
                multiple
                beforeUpload={() => false}
              >
                <Button
                  className="product-search-button add"
                  style={{
                    backgroundColor: "#117ffa",
                    color: "#ffffff",
                  }}
                >
                  이미지 추가
                </Button>
              </Upload>
              <Button
                danger
                className="product-explain-button-all-delete"
                onClick={handleAllImgDelete}
                disabled={productExplainImgList.length === 0}
              >
                전체 삭제
              </Button>
            </div>
            <Button
              onClick={imageSave}
              className="product-search-button register"
              style={{
                backgroundColor: "#117ffa",
                color: "#ffffff",
              }}
            >
              저장
            </Button>
          </Row>
        </div>
      }
      visible={isExplainProductModalOpen}
      onCancel={handleExplainProductModalCancel}
      onOk={handleExplainProductModalOk}
      width={"70%"}
      footer={""}
    >
      <div className="product-explain-modal-img-wrap">
        <div className="product-explain-img-container">
          {productExplainImgList?.length > 0 ? (
            productExplainImgList.map((item, idx) => (
              <>
                {item.uid === clickImageUid && (
                  <div className="product-explain-img-modify-icon-wrap">
                    <Upload
                      className="product-explain-img-modify-icon"
                      showUploadList={false}
                      onChange={(event) =>
                        handleProductExplainImg(event, "change")
                      }
                      beforeUpload={() => false}
                    >
                      <PictureOutlined />
                      <span className="product-explain-img-modify-icon-text">
                        교체
                      </span>
                    </Upload>
                    <div
                      className="product-explain-img-modify-icon"
                      onClick={handleProductExplainImgDelete}
                    >
                      <DeleteOutlined />
                      <span className="product-explain-img-modify-icon-text">
                        삭제
                      </span>
                    </div>
                  </div>
                )}
                <div
                  className={`product-explain-img-wrap product-explain-img-wrap-${
                    item.uid === clickImageUid ? "active" : "normal"
                  }`}
                >
                  <img
                    key={idx}
                    className={`product-explain-img-${
                      item.uid === clickImageUid ? "active" : "normal"
                    }`}
                    alt={`product-explain-image-${idx}`}
                    src={`${item.url}`}
                    onClick={() => {
                      setClickImageUid(item.uid);
                    }}
                    onKeyDown={(e) => {
                      handleKeyDownImgDelete(e);
                    }}
                    tabIndex="0"
                  />
                </div>
                {item.uid === clickImageUid && (
                  <Upload
                    className="product-explain-img-add-icon-wrap"
                    onChange={(event) => handleProductExplainImg(event, "add")}
                    showUploadList={false}
                    beforeUpload={() => false}
                    multiple
                  >
                    <PlusOutlined className="product-explain-img-add-icon" />
                  </Upload>
                )}
              </>
            ))
          ) : (
            <div className="product-explain-no-img-wrap">
              <Upload
                onChange={(event) => handleProductExplainImg(event, "add")}
                showUploadList={false}
                multiple
                beforeUpload={() => false}
              >
                <Button
                  className="product-search-button add"
                  style={{
                    backgroundColor: "#117ffa",
                    color: "#ffffff",
                  }}
                >
                  이미지 추가
                </Button>
              </Upload>
              <div className="product-explain-no-img-text">
                이미지가 없습니다
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ProductDetailExplainComponent;
